module.exports = __webpack_public_path__ + "ed76eb21560f0dc038cce0adfd65ea3c.woff";